import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import {
  BUSINESS_ROLE_GROUPS,
  COMMERCE_ROLE_GROUPS,
} from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

const Shippings = lazy(() => import('../Shippings'));
const CreateShippings = lazy(() => import('../pages/CreateShippings'));
const ViewShipping = lazy(() => import('../pages/ViewShipping'));
const EditShipping = lazy(() => import('../pages/EditShipping'));
const ImportShippings = lazy(() => import('../pages/ImportShippings/ImportShippings'));

/**
 * Escritura: back office con permisos de operación, o comercio con rol de
 * gestión. El comercio de solo lectura queda afuera de crear, importar y editar.
 */
const WRITE_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...COMMERCE_ROLE_GROUPS.write,
];

const IMPORT_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.withoutViewer,
  ...COMMERCE_ROLE_GROUPS.write,
];

const ShippingsRoutes: RouteObject[] = [
  {
    path: 'shippings',
    element: <Shippings />,
  },
  {
    path: 'shippings/create',
    element: (
      <Authorize
        permission={WRITE_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateShippings />
      </Authorize>
    ),
  },
  {
    path: 'shippings/import',
    element: (
      <Authorize
        permission={IMPORT_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ImportShippings />
      </Authorize>
    ),
  },
  {
    path: 'shipping/:number',
    element: <ViewShipping />,
  },
  {
    path: 'shipping/:number/edit',
    element: (
      <Authorize
        permission={WRITE_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditShipping />
      </Authorize>
    ),
  },
];

export default ShippingsRoutes;
